<div [ngClass]="mode === 'modify' ? 'connect-section' : 'create-section'" class="section-container mt-3 mb-3">
  <div class="auto-reply-section-content">
    <span class="mb-1 text-center auto-reply-section-content-label">AUTOMATE YOUR ANSWERS WITH CHATGPT</span>

    <div class="post-toggle-line mb-3">
      <span class="modal-link" (click)="showOptions = !showOptions"
        >ChatGPT Option<i *ngIf="!showOptions" class="fas fa-caret-down"></i> <i *ngIf="showOptions" class="fas fa-caret-up"></i
      ></span>
    </div>
    <ng-container *ngIf="!useIdetaKey && showOptions">
      <div class="post-toggle-line mb-3">
        <div class="post-toggle-title">Use your own OpenAI api key:</div>
        <app-toggle [value]="useIdetaKey === false" (toggle)="toggleUseOwnKey($event)"></app-toggle>
      </div>
      <div class="auto-reply-section-content">
        <label class="chatgpt-label-title text-center" for="api_key">ENTER YOUR OPENAI API KEY </label>
        <span class="chatgpt-text mb-3">
          Check out
          <a href="https://forum.ideta.io/t/how-to-get-an-open-ai-api-key/212" target="_blank">this forum post </a>
          to learn how to get an API key</span
        >
        <div class="select-action-container">
          <input
            type="text"
            class="edit-message-bloc-input"
            id="api_key"
            name="api_key"
            [(ngModel)]="api_key"
            #api_key_elmt="ngModel"
            placeholder="OpenAI API KEY..."
            (change)="setAPIKey(api_key_elmt.value)"
          />
          <button
            *ngIf="!spinning"
            class="custom-btn custom-btn-primary h-100"
            type="button"
            (click)="testAPIKey()"
            [disabled]="api_key.length === 0"
          >
            VALIDATE
          </button>
        </div>
        <div class="flex-grow-1 d-flex flex-column align-items-center justify-content-center mt-3" *ngIf="spinning">
          CHECKING IF YOUR API KEY IS VALID...
          <app-tiny-bot-spinner></app-tiny-bot-spinner>
        </div>
        <div *ngIf="!spinning && !isValidApiKey && testedApiKey" class="mt-3 text-center info-text">
          <div><i class="fas fa-exclamation-circle warning-text"></i> This API key is not valid! Please try again with another API key.</div>
        </div>
        <div *ngIf="!spinning && isValidApiKey && testedApiKey">
          <div class="mt-3 mb-3 mr-2 text-center info-text">
            <div><span class="text-success">✅ </span> This API key can be used!</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!spinning && (useIdetaKey || (isValidApiKey && testedApiKey))">
    <div class="auto-reply-section-content">
      <ng-container *ngIf="dicoModelLength > 1">
        <label class="chatgpt-label-title text-center" for="model"> SELECT CHATGPT MODEL : </label>
        <div>
          <app-simple-dropdown
            required
            id="model"
            [highlightSelectedItem]="true"
            [input]="modelForm"
            [dicoValues]="dicoModel"
            [textSize]="'1rem'"
            (postSelect)="setModel()"
          ></app-simple-dropdown>
        </div>
      </ng-container>
      <div class="text-info pricing-title"><i class="fas fa-info-circle"></i>Pricing:</div>
      <div *ngIf="!useIdetaKey" class="text-info">Reply using ChatGPT with own key: 3 Credits</div>
      <div *ngIf="useIdetaKey && !!modelForm.value && !!selectedModelInfo" class="text-info mb-2">
        Reply using {{ selectedModelInfo.name }}: {{ selectedModelInfo.price }} Credits
      </div>
    </div>
  </div>
</div>

<div *ngIf="useIdetaKey || (isValidApiKey && testedApiKey && validModel)" class="edit-messages mt-3 mb-3">
  <div [ngClass]="mode === 'modify' ? 'connect-section' : 'create-section'" class="edit-message-bloc mr-md-3">
    <h3 class="chatgpt-label-title">SEND A REACTION</h3>
    <div id="campaign_reaction" class="edit-message-bloc-input-reactions-container" *ngIf="displayAllowedReactions.length">
      <div class="add">
        <div class="edit-message-bloc-input-reactions w-100">
          <img
            *ngFor="let displayedReaction of displayAllowedReactions"
            class="edit-message-bloc-input-reactions-item"
            [class.selected]="displayedReaction === reaction ? true : false"
            src="/assets/img/fb-reactions/{{ displayedReaction }}.svg"
            alt="{{ displayedReaction }}"
            (click)="setReaction(displayedReaction)"
          />
        </div>
        <span [class.disabled]="!reaction" class="add-icon" *ngIf="displayAllowedReactions.length" (click)="addReaction()"
          ><i class="fas fa-plus"></i
        ></span>
      </div>
    </div>
    <div class="edit-message-bloc-input-reactions-container" *ngFor="let reaction of reactions; let i = index">
      <div class="edit-message-bloc-input-wrapper disabled">
        <div class="edit-message-bloc-input wrapped w-100">
          <img class="edit-message-bloc-input-reactions-item no-transform" src="/assets/img/fb-reactions/{{ reaction }}.svg" alt="{{ reaction }}" />
        </div>
        <div class="edit-message-bloc-input-actions">
          <i class="far fa-trash-alt" (click)="removeReaction(i)"></i>
        </div>
      </div>
    </div>
  </div>
  <ng-template #privateComingSoon>
    <div [ngClass]="mode === 'modify' ? 'connect-section' : 'create-section'" class="edit-message-bloc mr-md-3">
      <h3 class="edit-message-bloc-title">SEND INBOX MESSAGE</h3>
      <div class="private-coming-soon">Coming soon 👀</div>
    </div>
  </ng-template>
  <div [ngClass]="mode === 'modify' ? 'connect-section' : 'create-section'" class="edit-message-bloc mr-md-3">
    <div class="chatgpt-label-flex mb-1">
      <h3 class="chatgpt-label-title">RESPOND WITH PRIVATE MESSAGE</h3>
      <i class="far fa-trash-alt trash" (click)="setDefaultPrompt('private')"></i>
    </div>
    <div *ngIf="!addedPrivate">
      <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="setDefaultPrompt('private')">ADD PRIVATE MESSAGE</button>
    </div>
    <div *ngIf="addedPrivate">
      <div class="prompt-input-container mb-3">
        <label class="chatgpt-label-title-prompt text-center" for="template"> SELECT A PROMPT TEMPLATE TO USE: </label>
        <div class="template-dropdown">
          <app-simple-dropdown
            id="template"
            [highlightSelectedItem]="true"
            [input]="promptTemplatePrivateForm"
            [dicoValues]="dicoTemplatePrivate"
            [textSize]="'1rem'"
            (postSelect)="changePrompt('private')"
            [fullWidth]="true"
          ></app-simple-dropdown>
        </div>
        <div class="chatgpt-label-flex mb-1">
          <span class="chatgpt-label-title-prompt">EDIT YOUR PROMPT </span>
          <i class="fas fa-info-circle" [tooltip]="'Provide context or information for the language model to generate a response'"></i>
        </div>

        <div class="select-action-container prompt-btn-container">
          <button type="button" (click)="showPromptGeneratorModal('private')" class="open-prompt-btn custom-btn-primary">
            Need help generating prompt?
          </button>
          <textarea
            type="text"
            rows="15"
            class="edit-message-bloc-input chatgpt-prompt-input"
            id="prompt_private"
            name="prompt_private"
            [(ngModel)]="prompt_text_private"
            #prompt_private_elmt
            placeholder="TYPE SOMETHING..."
            (change)="setPrompt('private', prompt_text_private)"
          ></textarea>
        </div>
        <div class="text-btn-container">
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('private', prompt_private_elmt, 'post')">
            [INSERT POST]
          </button>
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('private', prompt_private_elmt, 'comment')">
            [INSERT COMMENT]
          </button>
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('private', prompt_private_elmt, 'name')">
            [INSERT COMMENTER'S NAME]
          </button>
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('private', prompt_private_elmt, 'postId')">
            [INSERT POST ID]
          </button>
          <button
            type="button"
            class="custom-btn custom-btn-small custom-btn-primary"
            (click)="addText('private', prompt_private_elmt, 'campaignId')"
          >
            [INSERT CAMPAIGN ID]
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--   <ng-template #privateComingSoon>
    <div class="edit-message-bloc connect-section mr-md-3">
      <h3 class="edit-message-bloc-title">RESPOND PRIVATELY IN DM</h3>
      <div class="private-coming-soon">Coming soon 👀</div>
    </div>
  </ng-template> -->
  <div [ngClass]="mode === 'modify' ? 'connect-section' : 'create-section'" class="edit-message-bloc">
    <div class="chatgpt-label-flex mb-1">
      <h3 class="chatgpt-label-title">RESPOND ON YOUR PUBLIC POST</h3>
      <i class="far fa-trash-alt trash" (click)="setDefaultPrompt('public')"></i>
    </div>
    <div *ngIf="!addedPublic">
      <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="setDefaultPrompt('public')">ADD PUBLIC MESSAGE</button>
    </div>
    <div *ngIf="addedPublic">
      <div class="prompt-input-container mb-3">
        <label class="chatgpt-label-title-prompt text-center" for="template"> SELECT A PROMPT TEMPLATE TO USE: </label>

        <div class="template-dropdown">
          <app-simple-dropdown
            id="template"
            [highlightSelectedItem]="true"
            [input]="promptTemplatePublicForm"
            [dicoValues]="dicoTemplatePublic"
            [textSize]="'1rem'"
            (postSelect)="changePrompt('public')"
            [fullWidth]="true"
          ></app-simple-dropdown>
        </div>
        <div class="chatgpt-label-flex mb-1">
          <span class="chatgpt-label-title-prompt">EDIT YOUR PROMPT</span>
          <i class="fas fa-info-circle" [tooltip]="'Provide context or information for the language model to generate a response'"></i>
        </div>
        <div class="select-action-container prompt-btn-container">
          <button type="button" (click)="showPromptGeneratorModal('public')" class="open-prompt-btn custom-btn-primary">
            Need help generating prompt?
          </button>
          <textarea
            type="text"
            rows="15"
            class="edit-message-bloc-input chatgpt-prompt-input"
            id="prompt_public"
            name="prompt_public"
            [(ngModel)]="prompt_text_public"
            #prompt_public_elmt
            placeholder="TYPE SOMETHING..."
            (change)="setPrompt('public', prompt_text_public)"
          ></textarea>
        </div>
        <div class="text-btn-container">
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('public', prompt_public_elmt, 'post')">
            [INSERT POST]
          </button>
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('public', prompt_public_elmt, 'comment')">
            [INSERT COMMENT]
          </button>
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('public', prompt_public_elmt, 'name')">
            [INSERT COMMENTER'S NAME]
          </button>
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('public', prompt_public_elmt, 'postId')">
            [INSERT POST ID]
          </button>
          <button type="button" class="custom-btn custom-btn-small custom-btn-primary" (click)="addText('public', prompt_public_elmt, 'campaignId')">
            [INSERT CAMPAIGN ID]
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
